import { render, staticRenderFns } from "./TableInfo.vue?vue&type=template&id=e71151f4&scoped=true"
import script from "./TableInfo.vue?vue&type=script&lang=js"
export * from "./TableInfo.vue?vue&type=script&lang=js"
import style0 from "./TableInfo.vue?vue&type=style&index=0&id=e71151f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71151f4",
  null
  
)

export default component.exports